module.exports = __webpack_public_path__ + "img/logo-indac-alt-filled.c57dd23f.png";